import React from 'react';

export default function AboutContent() {
  return (
    <div>
      <h3 className='oswald mt-2'>about me</h3>
      <p className='text-w200 m-0'>
        I am a student, currently studying computer science engineering. I am a
        web and mobile app developer. I primarily work with Javascript.
      </p>
      <p className='text-w200 m-0'>
        I have worked with vanilla js, react, react-native, node, express and
        always happy to learn and apply new technologies.
      </p>
      <p className='text-w200 mt-1'>
        Apart javascript, I have build some android apps using android studio
        (java) which are available on google play store. You can check them
        <a
          className='anchor-none'
          href='https://play.google.com/store/apps/developer?id=Akul+Srivastava'
        >
          {' '}
          here
        </a>
        .
      </p>
    </div>
  );
}
